<script>
import mixinGeometry from '../../../mixins/primitives/mixinGeometry'
export default {
  name: 'vc-geometry-outline-plane',
  mixins: [mixinGeometry]
}
</script>
